import { render, staticRenderFns } from "./HomecheckQuestions.vue?vue&type=template&id=32e2d125&scoped=true&"
import script from "./HomecheckQuestions.vue?vue&type=script&lang=ts&"
export * from "./HomecheckQuestions.vue?vue&type=script&lang=ts&"
import style0 from "./HomecheckQuestions.vue?vue&type=style&index=0&id=32e2d125&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e2d125",
  null
  
)

export default component.exports